import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Zoom,
  styled,
} from "@mui/material";

const UnifiedDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "40px",
    padding: theme.spacing(3),
    boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
    border: "1px solid rgba(255,255,255,0.3)",
  },
}));

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Conferma",
  cancelText = "Annulla",
  confirmColor = "#0b3d87",
}) => (
  <UnifiedDialog open={open} onClose={onClose} fullWidth maxWidth="xs" slots={{ transition: Zoom }}>
    <DialogTitle sx={{ color: confirmColor, fontWeight: 800, textAlign: "center", fontSize: "1.4rem", pb: 1 }}>
      {title}
    </DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ textAlign: "center", color: "#4a5568" }}>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 3, pt: 1, justifyContent: "center", gap: 2 }}>
      <Button
        onClick={onClose}
        sx={{ px: 4, borderRadius: 3, textTransform: "none", fontWeight: "bold", color: "#718096" }}
      >
        {cancelText}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          backgroundColor: confirmColor,
          px: 5,
          py: 1.2,
          borderRadius: 4,
          textTransform: "none",
          fontWeight: "bold",
          boxShadow: `0 8px 20px ${confirmColor}40`,
          "&:hover": { backgroundColor: confirmColor, filter: "brightness(1.1)" },
        }}
      >
        {confirmText}
      </Button>
    </DialogActions>
  </UnifiedDialog>
);

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmColor: PropTypes.string,
};

export default ConfirmDialog;
 